import KeenSlider from 'keen-slider'

window.addEventListener('DOMContentLoaded', () => {
	const prevBtn = document.querySelector('.testimonials-small_no_image .slider-nav .prev')
	const nextBtn = document.querySelector('.testimonials-small_no_image .slider-nav .next')

	var slider = new KeenSlider(
		'.testimonials-small_no_image .keen-slider',
		{
			loop: true,
			origin: 'center',
			slides: {
				perView: 3,
				spacing: 16,
			},
			defaultAnimation: {
				duration: 800,
			},
			breakpoints: {
				'(min-width: 512px)': {
					slides: {
						perView: 5,
						spacing: 24,
					}
				},
				'(min-width: 1200px)': {
					slides: {
						perView: 5,
						spacing: 32,
					}
				}
			},
		},
		[
			slider => {
				prevBtn.addEventListener('click', () => {
					slider.prev()
				})
				nextBtn.addEventListener('click', () => {
					slider.next()
				})
			},
		]
	)
})
